import Select from '@acri-tools/react-tools/components/Select/Select';
import { Component } from 'react';

import './ContactForm.css';


interface Props {
    contact: any
    onChange: (updates: any) => void
}


export default class RequestForm extends Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className="request-form">

                <div className="row-2">
                    <div className="form-field">
                        <label><i className="fas fa-user" /> Name</label>
                        <input
                            type="text" value={this.props.contact.name}
                            placeholder="Name" onChange={(e) => { this.props.onChange({ name: e.target.value }) }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-envelope" /> Email*</label>
                        <input
                            type="text" value={this.props.contact.email}
                            placeholder="Email" onChange={(e) => { this.props.onChange({ email: e.target.value }) }}
                        />
                    </div>
                </div>
                <div className="form-field">
                    <label><i className="fas fa-tools" /> Type*</label>

                    <Select
                        options={['RECIPIENT', 'COPY'].map((v) => { return { value: v, label: v } })}
                        value={this.props.contact.type}
                        onChange={(type: string) => { this.props.onChange({ type }) }}
                    />
                </div>
            </div>
        );
    }
};